import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NOB from '../../../../constants/language-strings';
import { CustomerInfoDetails } from './customer-info-details';
import styled from 'styled-components';
import { purpurColorFunctionalWhite, purpurColorGray800 } from '@purpurds/tokens/color/variables';
import { isPast } from 'utils/past-due-date';
import { purpurShadowMd } from '@purpurds/tokens/shadow/variables';
const CustomerInfoContent = styled.div `
  background-color: ${purpurColorFunctionalWhite};
  overflow: hidden;
  padding-top: 10px;
  border-radius: 0 0 4px 4px;
`;
export const CustomerInfoContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${purpurColorGray800};
  box-shadow: ${purpurShadowMd};
`;
export const Header = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.3em;
  padding: 10px 0 5px 16px;
  background-color: ${purpurColorFunctionalWhite};
  font-size: 20px;
  font-weight: 500;
  border-radius: 4px 4px 0 0;
`;
export const HeaderId = styled.span `
  font-weight: 400;
`;
export const CustomerInfo = ({ address, addressDetails, customer, openModal, workOrder, }) => {
    const isPastDue = isPast(workOrder === null || workOrder === void 0 ? void 0 : workOrder.serviceDate);
    return (_jsxs(CustomerInfoContainer, { children: [_jsxs(Header, { children: [_jsxs("div", { children: [_jsx("span", { children: NOB.CUSTOMER_INFO.CUSTOMER_ID }), "\u00A0", _jsx(HeaderId, { children: customer.customerId })] }), _jsxs("div", { children: [_jsx("span", { children: NOB.CUSTOMER_INFO.CUSTOMER_TYPE }), "\u00A0", _jsx(HeaderId, { children: addressDetails.addressType })] }), _jsxs("div", { children: [_jsx("span", { children: NOB.CUSTOMER_INFO.NETWORK }), "\u00A0", _jsx(HeaderId, { children: addressDetails.networkPlatform
                                    .map(platform => {
                                    switch (platform.name) {
                                        case 'HFC':
                                            const twoWay = addressDetails.hfcTwoWayNetwork
                                                ? '2-veis (TV og internett)'
                                                : '1-veis (kun TV)';
                                            return `HFC ${addressDetails.hfcDocsisVersion} ${twoWay}`;
                                        default:
                                            return platform.platformName;
                                    }
                                })
                                    .join(' | ') })] })] }), _jsx(CustomerInfoContent, { children: _jsx(CustomerInfoDetails, { address: address, customer: customer, openModal: openModal, isPastDue: isPastDue }) })] }));
};
